import { ChatUserSettings } from './agent.models';

export const LangCodeDescriptionEs = {
  es: 'Español',
  en: 'Inglés',
  it: 'Italiano',
  pt: 'Portugués',
  fr: 'Frances',
};

// TODO: use the default settings when the user is not set
export const defaultconvUserSettings: ChatUserSettings = {
  realTime: false,
  repeatRecording: false,
  // fixGrammar: false,
  superHearing: false,
  voice: '',
  // autoTranslate: false,
  highlightWords: true,
  synthVoice: true,
  model: { modelName: null, provider: 'google' },
  speed: null,
  speedRate: null, // temporal
  userMessageTask: true,
  assistantMessageTask: true,
};

export class VoiceTTSOption {
  provider: string;
  name: string;
  id: string;
  gender: 'male' | 'female';
  lang: string;
  exampleUrl: string;
}

export const VoiceTTSOptions: VoiceTTSOption[] = [
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇫🇷 fr-FR-Neural2-B',
    id: 'fr-FR-Neural2-B',
    gender: 'male',
    lang: 'fr-FR',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_fr-FR-Neural2-B.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇫🇷 fr-FR-Neural2-E',
    id: 'fr-FR-Neural2-E',
    gender: 'female',
    lang: 'fr-FR',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_fr-FR-Neural2-E.mp3',
  },
  // Italian
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇮🇹 it-IT-Neural2-A',
    id: 'it-IT-Neural2-A',
    gender: 'female',
    lang: 'it-IT',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_it-IT-Neural2-A.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️  🇮🇹 it-IT-Neural2-C',
    id: 'it-IT-Neural2-C',
    gender: 'male',
    lang: 'it-IT',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_it-IT-Neural2-C.mp3',
  },
  // Portuguese
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇧🇷 pt-BR-Neural2-C',
    id: 'pt-BR-Neural2-C',
    gender: 'female',
    lang: 'pt-BR',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_pt-BR-Neural2-C.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇧🇷 pt-BR-Neural2-B',
    id: 'pt-BR-Neural2-B',
    gender: 'male',
    lang: 'pt-BR',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_pt-BR-Neural2-B.mp3',
  },
  // Spanish
  {
    provider: 'google',
    name: '👨‍🦰 Man 🇲🇽 es-US-Neural2-B',
    id: 'es-US-Neural2-B',
    gender: 'male',
    lang: 'es-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-B.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇲🇽 es-US-Neural2-A',
    id: 'es-US-Neural2-A',
    gender: 'female',
    lang: 'es-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-A.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇲🇽 es-US-Neural2-C',
    id: 'es-US-Neural2-C',
    gender: 'male',
    lang: 'es-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-US-Neural2-C.mp3',
  },

  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇪🇸 es-ES-Neural2-B',
    id: 'es-ES-Neural2-B',
    gender: 'male',
    lang: 'es-ES',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-B.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇪🇸 es-ES-Neural2-C',
    id: 'es-ES-Neural2-C',
    gender: 'male',
    lang: 'es-ES',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-C.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇪🇸 es-ES-Neural2-F',
    id: 'es-ES-Neural2-F',
    gender: 'male',
    lang: 'es-ES',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-F.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇪🇸 es-ES-Neural2-E',
    id: 'es-ES-Neural2-E',
    gender: 'female',
    lang: 'es-ES',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_es-ES-Neural2-E.mp3',
  },

  // English
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-F',
    id: 'en-US-Journey-F',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-F.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-O',
    id: 'en-US-Journey-O',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-O.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-D',
    id: 'en-US-Journey-D',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Journey-D.mp3',
  },

  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Journey-N',
    id: 'en-US-News-N',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-News-N.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-News-L',
    id: 'en-US-News-L',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-News-L.mp3',
  },

  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Neural2-F',
    id: 'en-US-Neural2-F',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-F.mp3',
  },
  {
    provider: 'google',
    name: '👩 Woman ♀️ 🇺🇸 en-US-Neural2-H',
    id: 'en-US-Neural2-H',
    gender: 'female',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-H.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇺🇸 en-US-Neural2-J',
    id: 'en-US-Neural2-J',
    gender: 'male',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-J.mp3',
  },
  {
    provider: 'google',
    name: '👨‍🦰 Man ♂️ 🇺🇸 en-US-Neural2-I',
    id: 'en-US-Neural2-I',
    gender: 'male',
    lang: 'en-US',
    exampleUrl: 'https://storage.googleapis.com/appingles-pro.appspot.com/voice_demos/google_en-US-Neural2-I.mp3',
  },
];

export enum AudioSpeed {
  VerySlow = 'verySlow',
  Slow = 'slow',
  Regular = 'regular',
  Fast = 'fast',
  VeryFast = 'veryFast',
}

export enum TextEngines {
  SimpleText = 'simpleText',
  MarkdownMultiMessages = 'markdownMultiMessages',
  MarkdownSSML = 'markdownSSML',
}

export const TextEngineOptions = [
  { value: TextEngines.SimpleText, label: 'Simple Text Conversation' },
  { value: TextEngines.MarkdownMultiMessages, label: 'Markdown Multi Messages' },
  { value: TextEngines.MarkdownSSML, label: 'Markdown SSML Server Processed' },
];

export enum ConversationType {
  Default = 'default',
  General = 'general',
  Reflection = 'reflection',
  Challenge = 'challenge',
  RolePlay = 'rolePlay',
  RolePlayNoNarrator = 'rolePlayNoNarrator',
  RolePlayInnerThoughts = 'rolePlayInnerThoughts',
  LearningExample = 'learningExample',
  Scenario = 'scenario',
  LanguagePractice = 'languagePractice',
}

export const ConversationTypeOptions = [
  { value: ConversationType.Default, label: 'Default' },
  { value: ConversationType.General, label: 'General Conversation' },
  { value: ConversationType.Reflection, label: 'Reflection Conversation' },
  { value: ConversationType.Challenge, label: 'Challenge Conversation' },
  { value: ConversationType.RolePlay, label: 'Role Play Conversation' },
  { value: ConversationType.RolePlayNoNarrator, label: 'Role Play No Narrator Conversation' },
  { value: ConversationType.RolePlayInnerThoughts, label: 'Role Play Inner Thoughts Conversation' },
  { value: ConversationType.LearningExample, label: 'Learning Example Conversation' },
  { value: ConversationType.Scenario, label: 'Scenario Conversation' },
  { value: ConversationType.LanguagePractice, label: 'Language Practice Conversation' },
];
